<template>
  <div id="gkui-modal-controller">
    <transition name="fade">
      <div class="gkui-modal-layer" v-if="isShowLayer"></div>
    </transition>
    <template v-for="modal in modals">
      <component
        :is="modal.component"
        v-bind="modal.params"
        :style="{zIndex: 90000 + modal.params.zIndex}"
        :key="modal.params.id"
      />
    </template>
  </div>
</template>

<script>
import ModalPlugin from './index'
import utils from '../../utils'

export default {
  name: 'gkui-modal-controller',
  components: {
  },
  props: {

  },
  data () {
    return {
      isShowLayer: false,
      modals: [],
      zIndex: 0
    }
  },
  created () {
    this.$modal._setModalContainer(this)
  },
  beforeMount () {
    /**
     * 建立监听 toggle
     * @param {String}   name    弹出框标识
     * @param {Boolean}  state   弹出框的显示状态
     * @param {Object}   params  弹出框的数据
     */
    ModalPlugin.event.$on('toggle', (name, state, params) => {
      state ? this._eventToggleOpen(name, params) : this._eventToggleClose(name)
    })
  },
  mounted () {
  },
  destroyed () {
  },
  methods: {
    /**
     * 手动控制显示遮罩层
     * 外部控制 this.$modal.showLayer()
     */
    showLayer () {
      this.isShowLayer = true
      document.body.classList.add('gkui--modal-block-scroll')
    },
    /**
     * 手动控制关闭遮罩层
     * 外部控制 this.$modal.hideLayer()
     */
    hideLayer () {
      this.isShowLayer = false
      document.body.classList.remove('gkui--modal-block-scroll')
    },
    /**
     * 添加到 modal 列表
     * @param  {Component}  modal          弹出框 component
     * @param  {Object}     params         弹出框的数据，自动绑定到 component
     * @param  {Number}     params.zIndex  弹出框的层级，自动生成，只加不减
     * @param  {Object}     config         弹出框的配置
     * @param  {String}     config.name    弹出框的标识
     * @param  {Boolean}    config.auto    是否自动显示
     * @param  {Boolean}    config.layer   是否使用遮罩层
     */
    add (modal, params = {}, config) {
      let id = utils.guid()
      params.zIndex = ++this.zIndex

      config.auto = config.auto === undefined || config.auto
      config.layer = config.layer === undefined || config.layer

      let curModal = this.modals.find(item => config.name === item.name)

      /**
       * 判断是否是已加载过的弹出框
       * 如果是则更新 params 参数
       * 否则添加新的弹出框
       */
      if (curModal) {
        curModal.params = Object.assign({}, params)
      } else {
        this.modals.push({
          id: id,
          name: config.name,
          component: modal,
          params: params,
          layer: config.layer
        })
      }

      this.$nextTick(() => {
        config.auto && this.$modal.show(config.name, params)
      })
    },
    /**
     * 内部函数
     * 接收到弹出框已打开时更新内部数据 visible 设置为 true
     * 根据 layer 判断是否显示遮罩层
     * @param  {String} name 弹出框标识
     */
    _eventToggleOpen (name, params) {
      let curModal = this.modals.find(modal => modal.name === name)
      curModal.visible = true
      curModal.params = Object.assign({}, curModal.params, params)

      if (curModal.layer) {
        this.showLayer()
      }
    },
    /**
     * 内部函数
     * 接收到弹出框已关闭时更新内部数据 移除此弹出框
     * 遍历已打开的弹出框, 判断是否显示遮罩层
     * @param  {String} name 弹出框标识
     */
    _eventToggleClose (name) {
      let flag = false
      let removeIndex
      let removeModal // 记录要关闭的 组件 数据

      for (let i in this.modals) {
        if (this.modals[i].name === name) {
          removeIndex = i
          removeModal = this.modals[i]
        } else {
          if (this.modals[i].visible && this.modals[i].layer) {
            flag = true
          }
        }
      }

      removeIndex !== undefined && this.modals.splice(removeIndex, 1)

      !flag && removeModal.layer && this.hideLayer()
    }
  }
}
</script>

<style lang="scss">

.gkui--modal-block-scroll {
  position: absolute;
  overflow: hidden;
  width: 100vw;
}
#gkui-modal-controller {
  position: fixed; left: 0; top: 0; z-index: 90000;
  width: 100%;
}
.gkui-modal-layer {
  position: fixed; left: 0; top: 0; right: 0; bottom: 0; z-index: 90000;
  background-color: rgba(55, 55, 55, 0.3);
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  // transform: scale(0.9);
}
</style>
